import React, { useMemo, useState } from "react";
import { T } from "../theme";
import { Badge, Card, fmt, SectionTitle, TapeIcon } from "../ui";

const TYPE_LABEL = { sale: "For Sale", trade: "For Trade", both: "Sale or Trade" };

export default function MarketplaceScreen({ activeListings, soldListings, myListings, onSelect, onSelectMine }) {
  const [tab, setTab] = useState("browse");
  const [q, setQ] = useState("");

  const browsable = useMemo(() => [...activeListings, ...soldListings], [activeListings, soldListings]);

  const filtered = useMemo(() => {
    const needle = q.toLowerCase();
    if (!needle) return browsable;
    return browsable.filter((l) => l.artist?.toLowerCase().includes(needle) || l.albumTitle?.toLowerCase().includes(needle));
  }, [browsable, q]);

  return (
    <div>
      <div style={{ display: "flex", background: T.statBg, borderRadius: 10, padding: 4, marginBottom: 14 }}>
        {[["browse", "Browse"], ["mine", "My Listings"]].map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)} style={{ flex: 1, background: tab === key ? T.accent : "transparent", border: "none", color: tab === key ? "#fff" : T.muted, padding: "8px 0", borderRadius: 7, cursor: "pointer", fontSize: 12, fontWeight: "bold", fontFamily: T.font, letterSpacing: "0.08em" }}>{label}</button>
        ))}
      </div>

      {tab === "browse" && (
        <div>
          <div style={{ position: "relative", marginBottom: 12 }}>
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search listings…"
              style={{ width: "100%", background: T.inputBg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "10px 36px 10px 12px", fontSize: 13, fontFamily: T.font, outline: "none", boxSizing: "border-box" }} />
            <span style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", color: T.muted, fontSize: 16 }}>🔍</span>
          </div>
          {filtered.length === 0 ? (
            <div style={{ textAlign: "center", padding: 32, fontSize: 13, color: T.muted }}>No listings yet. Be the first to list a tape.</div>
          ) : (
            filtered.map((l) => (
              <Card key={l.id} onClick={() => onSelect(l)} style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer", opacity: l.status === "sold" ? 0.6 : 1 }}>
                {l.mainPhotoUrl ? (
                  <img src={l.mainPhotoUrl} alt={l.albumTitle} style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 8 }} />
                ) : (
                  <TapeIcon size={44} />
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: "bold", color: T.text }}>{l.albumTitle}</div>
                  <div style={{ fontSize: 11, color: T.muted }}>{l.artist}{l.releaseYear ? ` · ${l.releaseYear}` : ""}</div>
                  <div style={{ fontSize: 10, color: T.muted, marginTop: 1 }}>by {l.sellerDisplayName || "Collector"}</div>
                  <div style={{ display: "flex", gap: 6, alignItems: "center", marginTop: 4 }}>
                    {l.condition && <Badge condition={l.condition} />}
                    {l.status === "sold" ? (
                      <span style={{ fontSize: 9, background: T.border, color: T.muted, padding: "2px 7px", borderRadius: 4 }}>SOLD</span>
                    ) : (
                      <span style={{ fontSize: 9, color: T.accent, fontWeight: "bold", letterSpacing: "0.05em" }}>{TYPE_LABEL[l.listingType]}</span>
                    )}
                  </div>
                </div>
                {l.price != null && <div style={{ fontSize: 16, fontWeight: "bold", color: T.value }}>{fmt(l.price)}</div>}
              </Card>
            ))
          )}
        </div>
      )}

      {tab === "mine" && (
        <div>
          <SectionTitle>Your Listings</SectionTitle>
          {myListings.length === 0 ? (
            <Card style={{ textAlign: "center", padding: 24 }}>
              <div style={{ fontSize: 13, color: T.muted }}>You haven't listed anything yet. Open a tape from your Collection and tap "List for Sale/Trade."</div>
            </Card>
          ) : (
            myListings.map((l) => (
              <Card key={l.id} onClick={() => onSelectMine(l)} style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer", opacity: l.status === "sold" ? 0.6 : 1 }}>
                {l.mainPhotoUrl ? (
                  <img src={l.mainPhotoUrl} alt={l.albumTitle} style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 8 }} />
                ) : (
                  <TapeIcon size={44} />
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: "bold", color: T.text }}>{l.albumTitle}</div>
                  <div style={{ fontSize: 11, color: T.muted }}>{l.artist}</div>
                  <span style={{ fontSize: 9, color: l.status === "sold" ? T.muted : T.accent, fontWeight: "bold", letterSpacing: "0.05em", textTransform: "uppercase" }}>{l.status}</span>
                </div>
                {l.price != null && <div style={{ fontSize: 16, fontWeight: "bold", color: T.value }}>{fmt(l.price)}</div>}
              </Card>
            ))
          )}
        </div>
      )}
    </div>
  );
}
